export default __webpack_public_path__ + "static/media/14.6acc1928.jpeg";